import { SimpleTranslationItem } from '@/models/SimpleTranslationItem';

export class ProductPageViewModel {
    Id: number;
    Name: string;
    MetaTitle: string;
    MetaDescription: string;
    Keywords: string;
    Description: string;
    ShortDescription: string;
    PhotoUrl: string;
    PhotoDescription: string;
    ProductPhotoList: Array<string>;
    RecommendProductList: Array<string>;
    Price: number;
    Currency: string;
    IsSubscribe: boolean;
    IsActiveSubscribe: boolean;
    SubscriptionId: number;
    // FIXME :Partner: Fix GUI: ProductItemServiceModel: Use Partner instead PartnerId
    PartnerId: number;
    // FIXME :Partner: Fix GUI: ProductItemServiceModel: Use Partner instead PartnerSlug
    PartnerSlug: string;
    // FIXME :Partner: Fix GUI: ProductItemServiceModel: Use Partner instead PartnerName
    PartnerName: string;
    // FIXME :Partner: Fix GUI: ProductItemServiceModel: Use Partner instead PartnerDescription
    PartnerDescription: string;
    // FIXME :Partner: Fix GUI: ProductItemServiceModel: Use Partner instead PartnerPhotoUrl
    PartnerPhotoUrl: string;
    IsComingSoon: boolean;
    Slug: string;

    constructor(initializer?: ProductPageViewModel) {
        this.Id = initializer ? initializer.Id : -1;
        this.Name = initializer ? initializer.Name : "";
        this.Description = initializer ? initializer.Description : "";
        this.MetaTitle = initializer ? initializer.MetaTitle : "";
        this.MetaDescription = initializer ? initializer.MetaDescription : "";
        this.Keywords = initializer ? initializer.Keywords : "";
        this.ShortDescription = initializer ? initializer.ShortDescription : "";
        this.PhotoUrl = initializer ? initializer.PhotoUrl : "";
        this.PhotoDescription = initializer ? initializer.PhotoDescription : "";
        this.ProductPhotoList = initializer ? initializer.ProductPhotoList : new Array<string>();
        this.RecommendProductList = initializer ? initializer.RecommendProductList : new Array<string>();
        this.Price = initializer ? initializer.Price : 0;
        this.Currency = initializer ? initializer.Currency : "";
        this.IsSubscribe = initializer ? initializer.SubscriptionId > 0 : false;
        this.IsActiveSubscribe = initializer ? initializer.IsActiveSubscribe : false;
        this.SubscriptionId = initializer ? initializer.SubscriptionId : -1;
        this.PartnerId = initializer ? initializer.PartnerId : -1;
        this.PartnerSlug = initializer ? initializer.PartnerSlug : "";
        this.PartnerName = initializer ? initializer.PartnerName : "";
        this.PartnerDescription = initializer ? initializer.PartnerDescription : "";
        this.PartnerPhotoUrl = initializer ? initializer.PartnerPhotoUrl : "";
        this.IsComingSoon = initializer ? initializer.IsComingSoon : false;
        this.Slug = initializer ? initializer.Slug : "";
    }
}